'use strict';

export class MathFunctions{

  public isBase64 = ( value: string ): boolean => {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

    return base64regex.test( value );
  };
}
